export interface IInvoiceException {
	invoiceExceptionID: number;
	invoiceDetailID: number;
	invoiceExceptionTypeID: number;
	exceptionType: string;
	invoiceExceptionStatusID: number;
	exceptionStatus: string;
	exceptionNotes: string;
	createDate: string;
	createdBy: number;
	lastModifiedDate?: string;
	lastModifiedBy?: number;
}

export enum InvoiceExceptionStatus {
	Open = 1,
	Resolved = 2,
	WaitingOnInstructor = 3
}
